var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('my-header',{attrs:{"header":_vm.header,"userInfo":_vm.userInfo},on:{"login":_vm.initUserInfo,"logout":_vm.logout}}),_c('keep-alive',[_c('router-view',{ref:_vm.$route.fullPath,on:{"login":_vm.initUserInfo}})],1),_c('el-backtop'),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }